// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { flowController } from "../../game_theme/flow_fb/flowController";
import { CardSettings } from "../settings/Settings";
import { AngryAnalytics } from "./Analytics/Analytics";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var DailyRewardManager = {
    DAY_1_TAG: "dailyRewardDay1",
    PREVIOUS_DAY_TAG: "dailyRewardPreviousDay",
    TERENCE_TIMER_TAG: "dailyRewardTerenceTimer",
    CYCLE_TAG: "dailyRewardCycle",
    TERENCE_TIMER_DURATION: CardSettings.terenceTimerDuration * 60 * 60 * 1000,
    LAST_DAY: 4,
    REWARD_TYPES: {
        POWERUP: "POWERUP",
        TERENCE: "TERENCE"
    },
    isInitialized: false,
    day1: null,
    previousDay: null,
    currentDay: null,
    terenceEndTime: null,
    _currentCycle: null,
    justUnlockedTerence: false,
    hasFinishedTurn: false,
    firstTimeOpen: false,
    initialize: function () {
        var self = this;
        YoutubeStorageManager.getPlayerData([DailyRewardManager.DAY_1_TAG, DailyRewardManager.PREVIOUS_DAY_TAG, DailyRewardManager.TERENCE_TIMER_TAG, DailyRewardManager.CYCLE_TAG], function (data) {
            self.day1 = data[DailyRewardManager.DAY_1_TAG] || 0;
            self.firstTimeOpen = (data[DailyRewardManager.DAY_1_TAG] === undefined) ? true : false;
            self.previousDay = data[DailyRewardManager.PREVIOUS_DAY_TAG] || 0;
            self.terenceEndTime = data[DailyRewardManager.TERENCE_TIMER_TAG] || 0;
            self._currentCycle = data[self.CYCLE_TAG] || 0;
            self.currentDay = self._calculateEpochDays();
            self.isInitialized = true;
            if (self._reachedNextCycle()) {
                self.day1 = self.currentDay;
                self._currentCycle++;
            }
            if (!self.firstTimeOpen && self._failedToClaim()) {
                AngryAnalytics.reportDailyRewardReset(self._currentCycle);
                self.day1 = self.currentDay;
            }
        }, function (e) {
            throw new Error(e);
        });
    },
    getCurrentDay: function () {
        if (!this.isInitialized) {
            throw new Error("DailyRewardManager is not initialized");
        }
        return this.currentDay - this.day1;
    },
    getCurrentReward: function (rewardAtDay) {
        if (!this.isInitialized) {
            throw new Error("DailyRewardManager is not initialized");
        }
        var day = rewardAtDay ? rewardAtDay : this.getCurrentDay();
        return day === this.LAST_DAY ? DailyRewardManager.REWARD_TYPES.TERENCE : DailyRewardManager.REWARD_TYPES.POWERUP;
    },
    onClaimReward: function () {
        if (!this.isInitialized) {
            throw new Error("DailyRewardManager is not initialized");
        }
        AngryAnalytics.reportDailyReward(this.getCurrentDay(), this._currentCycle);
        this.previousDay = this.currentDay;
        this._saveToServer();
    },
    hasClaimedRewardToday: function () {
        if (!this.isInitialized) {
            throw new Error("DailyRewardManager is not initialized");
        }
        return this.previousDay === this.currentDay;
    },
    startTerenceTimer: function () {
        this.terenceEndTime = flowController.getServerTime() + this.TERENCE_TIMER_DURATION;
        this.justUnlockedTerence = true;
        AngryAnalytics.reportDailyRewardCompleted(this._currentCycle);
        YoutubeStorageManager.savePlayerData([DailyRewardManager.TERENCE_TIMER_TAG], [this.terenceEndTime], function () { }, function (e) {
            console.error(e);
        });
    },
    getTerenceTimeRemaining: function () {
        return this.terenceEndTime - flowController.getServerTime();
    },
    isTerenceActive: function () {
        return this.getTerenceTimeRemaining() > 0;
    },
    isFirstTerenceTurn: function () {
        return !this.hasFinishedTurn && this.justUnlockedTerence;
    },
    onFinishTurn: function () {
        this.hasFinishedTurn = true;
    },
    _saveToServer: function () {
        YoutubeStorageManager.savePlayerData([DailyRewardManager.DAY_1_TAG, DailyRewardManager.PREVIOUS_DAY_TAG, DailyRewardManager.CYCLE_TAG], [this.day1, this.previousDay, this._currentCycle], function () { }, function (e) {
            console.error(e);
        });
    },
    _reachedNextCycle: function () {
        return this.getCurrentDay() > this.LAST_DAY;
    },
    _failedToClaim: function () {
        var epochDays = this._calculateEpochDays();
        return epochDays > this.previousDay + 1;
    },
    _calculateEpochDays: function () {
        var serverTime = flowController.getLocalTime();
        return Math.floor(serverTime / 86400000);
    }
};
